module.exports = "mutation UpdateLineShippingQuantity($lines:[LineShippingQuantityInput]!){updateLineShippingQuantity(lines:$lines){success}}"